import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    // Optional: Check if buttons are needed (if content overflows)
  }

  scrollLeft() {
    const card = this.trackTarget.querySelector('.teacher-card, .eg-testimonial-card, .eg-video-item') || this.trackTarget.firstElementChild
    if (!card) return

    const cardWidth = card.offsetWidth
    const gap = 32 // 2rem roughly
    this.trackTarget.scrollBy({
      left: -(cardWidth + gap),
      behavior: 'smooth'
    })
  }

  scrollRight() {
    const card = this.trackTarget.querySelector('.teacher-card, .eg-testimonial-card, .eg-video-item') || this.trackTarget.firstElementChild
    if (!card) return

    const cardWidth = card.offsetWidth
    const gap = 32
    this.trackTarget.scrollBy({
      left: (cardWidth + gap),
      behavior: 'smooth'
    })
  }
}
